(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["byos-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var root = document.querySelector('[data-byos]');
  if (!root || root.dataset.byosInit) return;
  root.dataset.byosInit = '1';

  var CONFIG = {
    key: root.dataset.byosKey || 'byos',
    size: parseInt(root.dataset.stackSize, 10) || 2,
    price: parseInt(root.dataset.stackPrice, 10) || 0,
    moneyFormat: root.dataset.moneyFormat || ('\u20B9' + '{' + '{amount}' + '}'),
    bundleVariantId: root.dataset.bundleVariantId || '',
    bundleProductTitle: root.dataset.bundleProductTitle || '',
    discountCode: root.dataset.discountCode || ''
  };
  var STORAGE_KEY = 'byos:' + CONFIG.key;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    var amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return CONFIG.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount);
  }
  function uid() { return CONFIG.key + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }

  var stack = load();
  function load() { try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; } }
  function save() { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stack)); }

  var tray = $('[data-byos-tray]'), slotsEl = $('[data-byos-slots]'), selectedEl = $('[data-byos-selected]'),
      originalEl = $('[data-byos-original]'), saveEl = $('[data-byos-save]'), metaEl = $('[data-byos-meta]'), checkoutBtn = $('[data-byos-checkout]'),
      dialog = $('[data-byos-variant-dialog]'), dialogBody = $('[data-byos-variant-body]');

  function addToStack(item) {
    if (stack.length >= CONFIG.size) { flash('Your stack is full. Remove an item to swap.'); return; }
    stack.push(item); save(); render();
  }
  function removeAt(i) { stack.splice(i, 1); save(); render(); }

  function render() {
    if (!tray) return;
    tray.hidden = false;
    selectedEl.textContent = stack.length;
    $$('.byos-slot', slotsEl).forEach(function (slot, i) {
      var item = stack[i];
      if (item) {
        slot.classList.remove('is-empty');
        slot.innerHTML = '<img src="' + item.image + '" alt="" class="byos-slot__img">' +
          '<span class="byos-slot__name">' + item.title + '</span>' +
          '<button type="button" class="byos-slot__remove" aria-label="Remove">&times;</button>';
        slot.querySelector('.byos-slot__remove').addEventListener('click', function () { removeAt(i); });
      } else {
        slot.classList.add('is-empty');
        slot.innerHTML = '<span class="byos-slot__placeholder">Select Item</span>';
      }
    });
    var original = stack.reduce(function (s, it) { return s + (it.price || 0); }, 0);
    var full = stack.length === CONFIG.size;
    originalEl.textContent = original ? money(original) : '';
    saveEl.textContent = (full && original > CONFIG.price) ? 'Save ' + money(original - CONFIG.price) : '';
    if (metaEl) metaEl.hidden = !(full && original > CONFIG.price);
    checkoutBtn.disabled = !full;
    checkoutBtn.textContent = full ? 'Add Stack to Cart' : 'Select ' + (CONFIG.size - stack.length) + ' more';
    $$('[data-byos-card]').forEach(function (card) {
      var inStack = stack.some(function (it) { return String(it.productId) === String(card.dataset.productId); });
      card.classList.toggle('is-in-stack', inStack);
    });
  }

  function chooseVariant(btn) {
    return fetch(btn.dataset.productJsonUrl).then(function (r) { return r.json(); }).then(function (product) {
      var purchasable = product.variants.filter(function (v) { return v.available; });
      if (purchasable.length <= 1) return variantToItem(product, purchasable[0] || product.variants[0]);
      return new Promise(function (resolve) {
        dialogBody.innerHTML = '<h4 class="byos-variant-dialog__title">' + product.title.replace(/:BYOS/i, '').trim() + '</h4>' +
          '<p class="byos-variant-dialog__hint">Choose an option</p><ul class="byos-variant-dialog__list">' +
          purchasable.map(function (v) { return '<li><button type="button" class="byos-variant-dialog__opt" data-vid="' + v.id + '">' + v.title + ' \u2014 ' + money(v.price) + '</button></li>'; }).join('') +
          '</ul><button type="button" class="byos-variant-dialog__close" data-close>Cancel</button>';
        if (typeof dialog.showModal === 'function') dialog.showModal();
        dialogBody.querySelectorAll('.byos-variant-dialog__opt').forEach(function (opt) {
          opt.addEventListener('click', function () {
            var v = product.variants.filter(function (x) { return String(x.id) === opt.dataset.vid; })[0];
            dialog.close(); resolve(variantToItem(product, v));
          });
        });
        dialogBody.querySelector('[data-close]').addEventListener('click', function () { dialog.close(); resolve(null); });
      });
    }).catch(function () {
      return { productId: null, variantId: btn.dataset.variantId, title: btn.dataset.title, price: parseInt(btn.dataset.price, 10), image: btn.dataset.image };
    });
  }
  function variantToItem(product, v) {
    return { productId: product.id, variantId: v.id,
      title: product.title.replace(/:BYOS/i, '').trim() + (v.title !== 'Default Title' ? ' \u2014 ' + v.title : ''),
      price: v.price, image: (v.featured_image && v.featured_image.src) || product.featured_image || '' };
  }

  function openCartSidebar() {
    document.body.classList.add('cart-sidebar-show');
    if (window.Shopify && typeof Shopify.getCart === 'function') {
      Shopify.getCart(function (cart) {
        if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
          window.halo.updateSidebarCart(cart);
        } else if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
          window.sharedFunctions.updateSidebarCart(cart);
        }
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    } else {
      window.location.href = '/cart';
    }
  }

  function checkout() {
    if (stack.length !== CONFIG.size) return;
    checkoutBtn.disabled = true; checkoutBtn.textContent = 'Adding\u2026';
    var stackId = uid();

    if (CONFIG.bundleVariantId) {
      var properties = {
        '_byos': CONFIG.key,
        '_byos_stack': stackId,
        '_byos_bundle': 'true',
        '_byos_price': String(CONFIG.price)
      };
      stack.forEach(function (it, idx) {
        properties['Piece ' + (idx + 1)] = it.title;
        if (it.image) properties['_item_' + (idx + 1) + '_img'] = it.image;
        if (it.variantId) properties['_item_' + (idx + 1) + '_id'] = String(it.variantId);
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(CONFIG.bundleVariantId, 10),
            quantity: 1,
            properties: properties
          }]
        })
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        stack = []; save(); render();
        openCartSidebar();
      })
      .catch(function (err) {
        console.error(err);
        flash('Could not add your stack. Please try again.');
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'Add Stack to Cart';
      });
    } else {
      var items = stack.map(function (it, idx) {
        return {
          id: it.variantId,
          quantity: 1,
          properties: {
            '_byos': CONFIG.key,
            '_byos_stack': stackId,
            '_byos_price': CONFIG.price,
            'Offer': 'Buy ' + CONFIG.size + ' @ ' + money(CONFIG.price)
          }
        };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        stack = []; save(); render();
        if (CONFIG.discountCode) {
          localStorage.setItem('storedDiscount', CONFIG.discountCode);
          fetch('/discount/' + encodeURIComponent(CONFIG.discountCode))
            .then(function () { openCartSidebar(); })
            .catch(function () { openCartSidebar(); });
        } else {
          openCartSidebar();
        }
      })
      .catch(function (err) {
        console.error(err);
        flash('Could not add your stack. Please try again.');
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'Add Stack to Cart';
      });
    }
  }

  var toastEl;
  function flash(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'byos-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(flash._t); flash._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  root.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-byos-add]');
    if (addBtn) {
      e.preventDefault();
      if (stack.length >= CONFIG.size) { flash('Your stack is full.'); return; }
      addBtn.classList.add('is-loading');
      chooseVariant(addBtn).then(function (item) { addBtn.classList.remove('is-loading'); if (item) addToStack(item); });
    }
  });
  if (checkoutBtn) checkoutBtn.addEventListener('click', checkout);
  if (dialog) dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

  var filterToggle = $('[data-byos-filters-toggle]'), filters = $('.byos__filters');
  if (filterToggle && filters) filterToggle.addEventListener('click', function () {
    var open = filters.classList.toggle('is-open'); filterToggle.setAttribute('aria-expanded', String(open));
  });
  var filterForm = $('[data-byos-filter-form]');
  if (filterForm) filterForm.addEventListener('change', function () { filterForm.submit(); });

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delivery-estimator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var TIMEZONE = "Asia/Kolkata";
  var CFG = null;

  /* ---------- Safari-safe session flags ---------- */
  var __memFlags = {};
  function getSessionFlag(key) {
    try { var v = sessionStorage.getItem(key); if (v !== null) return v; } catch (e) {}
    if (__memFlags[key]) return __memFlags[key];
    var m = document.cookie.match(new RegExp('(?:^|; )' + key + '=([^;]*)'));
    return m ? m[1] : null;
  }
  function setSessionFlag(key, value) {
    value = value || 'true';
    try { sessionStorage.setItem(key, value); return; } catch (e) {}
    __memFlags[key] = value;
    document.cookie = key + '=' + value + '; path=/; SameSite=Lax';
  }

  /* ---------- LS with cookie fallback ---------- */
  function safeSetLS(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); return; }
    catch (e) { document.cookie = key + '=' + encodeURIComponent(JSON.stringify(value)) + '; path=/; max-age=31536000'; }
  }
  function safeGetLS(key) {
    try { var v = localStorage.getItem(key); if (v !== null) return JSON.parse(v); } catch (e) {}
    var m = document.cookie.match(new RegExp('(?:^|; )' + key + '=([^;]*)'));
    if (m) { try { return JSON.parse(decodeURIComponent(m[1])); } catch (e2) { return null; } }
    return null;
  }
  function getFromLocalStorage(key) { return safeGetLS(key); }

  /* ---------- Time helpers ---------- */
  function getISTNow() { return new Date(new Date().toLocaleString("en-US", { timeZone: TIMEZONE })); }
  function getFutureDate(days) {
    if (days === null || days === undefined) return null;
    var d = getISTNow();
    d.setDate(d.getDate() + Number(days));
    return d.toLocaleDateString("en-IN", { weekday: "short", day: "2-digit", month: "short" });
  }

  /* ---------- TAT lookup (Papa if present, else fallback) ---------- */
  function parseCSVFallback(text) {
    var lines = text.split(/\r?\n/).filter(function (l) { return l.trim().length; });
    if (!lines.length) return [];
    var headers = lines[0].split(',').map(function (h) { return h.trim(); });
    return lines.slice(1).map(function (line) {
      var cells = line.split(',');
      var obj = {};
      headers.forEach(function (h, i) { obj[h] = (cells[i] || '').trim(); });
      return obj;
    });
  }
  function findRow(rows, zipcode) {
    var row = rows.find(function (r) { return String(r['Zipcode']).trim() == String(zipcode).trim(); });
    if (!row) return null;
    return {
      Zipcode: row['Zipcode'], City: row['City'], State: row['State'],
      'Standard Delivery': row['Standard Delivery'],
      'Express Delivery': row['Express Delivery'],
      'Same Day': row['Same Day']
    };
  }
  function fetchAndParseExcel(url, zipcode) {
    return fetch(url).then(function (res) { return res.text(); }).then(function (csvText) {
      if (window.Papa) {
        return new Promise(function (resolve) {
          window.Papa.parse(csvText, {
            header: true, skipEmptyLines: true,
            complete: function (results) { resolve(findRow(results.data, zipcode)); }
          });
        });
      }
      return findRow(parseCSVFallback(csvText), zipcode);
    });
  }

  function fetchCartData() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  /* ---------- Mapbox v6 reverse geocode ---------- */
  function detectPincodeUsingMapboxV6(accessToken) {
    return new Promise(function (resolve, reject) {
      if (!navigator.geolocation) { reject(new Error("Geolocation not supported")); return; }
      navigator.geolocation.getCurrentPosition(function (position) {
        var c = position.coords;
        window.customer_position = { latitude: c.latitude, longitude: c.longitude };
        var url = 'https://api.mapbox.com/search/geocode/v6/reverse?longitude=' + c.longitude +
          '&latitude=' + c.latitude + '&access_token=' + encodeURIComponent(accessToken);
        fetch(url).then(function (res) {
          if (!res.ok) throw new Error('Mapbox v6 failed: ' + res.status);
          return res.json();
        }).then(function (data) {
          var features = data.features || [];
          if (!features.length) throw new Error("No reverse geocoding results");
          var pf = features.find(function (f) { return f.properties && f.properties.feature_type === "postcode"; }) ||
                   features.find(function (f) { return f.properties && f.properties.context && f.properties.context.postcode; });
          var postcode = (pf && pf.properties && pf.properties.name) ||
                         (pf && pf.properties && pf.properties.context && pf.properties.context.postcode && pf.properties.context.postcode.name) || null;
          if (!postcode) throw new Error("Pincode not found (Mapbox v6)");
          var ctx = (pf && pf.properties && pf.properties.context) || (features[0].properties && features[0].properties.context) || {};
          var loc = {
            pincode: postcode,
            city: (ctx.place && ctx.place.name) || (ctx.neighborhood && ctx.neighborhood.name) || null,
            state: (ctx.region && ctx.region.name) || null,
            country: (ctx.country && ctx.country.name) || null,
            accuracyMeters: c.accuracy != null ? c.accuracy : null,
            provider: "mapbox-v6", latitude: c.latitude, longitude: c.longitude
          };
          safeSetLS('user_position', loc);
          resolve(loc);
        }).catch(reject);
      }, function (err) { reject(new Error(err.message)); }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 });
    });
  }

  /* ---------- Availability ---------- */
  function getDeliveryAvailabilityByZipcode(zipcode) {
    var zip = String(zipcode == null ? "" : zipcode).trim();
    var fastest = { method: null, days: null };
    var base = {
      single_day_delivery: { allowed: false },
      next_day_delivery: { allowed: false },
      express_delivery: { allowed: false, days: null },
      standard_delivery: { allowed: false, days: null }
    };
    if (!zip || zip.length < 5) return Promise.resolve({ deliveryOptions: base, fastestDelivery: fastest });

    return fetchAndParseExcel(CFG.tatUrl, zip).then(function (row) {
      if (!row) return { deliveryOptions: base, fastestDelivery: fastest };
      var standardDays = Number(row["Standard Delivery"]);
      var expressDays = Number(row["Express Delivery"]);
      var sameDayFlag = Number(row["Same Day"]);

      if (isFinite(standardDays) && standardDays > 0) {
        base.standard_delivery.allowed = true; base.standard_delivery.days = standardDays;
        fastest.days = standardDays; fastest.method = 'Standard Delivery';
      }
      if (isFinite(expressDays) && expressDays > 0) {
        base.express_delivery.allowed = true; base.express_delivery.days = expressDays;
        if (fastest.days > expressDays) { fastest.method = 'Express Delivery'; fastest.days = expressDays; }
      }
      if (isFinite(sameDayFlag) && sameDayFlag > 0) {
        base.single_day_delivery.allowed = true; base.single_day_delivery.days = 0;
        var cutoffCrossed = getISTNow().getHours() >= CFG.cutoffHour;
        if (cutoffCrossed) {
          base.next_day_delivery.allowed = true; base.next_day_delivery.days = 1;
          base.single_day_delivery.allowed = false;
          if (fastest.days > 1) { fastest.method = 'Next Day Delivery'; fastest.days = 1; }
        } else if (fastest.days > 0) { fastest.method = 'Same Day'; fastest.days = 0; }
      }
      return { deliveryOptions: base, fastestDelivery: fastest };
    });
  }

  /* ---------- UI ---------- */
  function showDeliveryMsg(currentLocation, fastestDate) {
    var text = fastestDate
      ? '🚚 Estimated delivery by <strong class="de-eta-em">' + fastestDate + '</strong> <span id="delETAText">to ' + currentLocation.pincode + '</span>'
      : '🚚 Delivery date not available <span id="delETAText">to ' + currentLocation.pincode + '</span>';

    var deliveryText = document.querySelector("#deliveryText");
    if (deliveryText) deliveryText.innerHTML = text;

    var cartETA = document.querySelector("#cartDeliveryETA .cart-summary__delivery-label");
    if (cartETA) { cartETA.innerHTML = text; var tmp = document.querySelector("#cartDeliveryETA"); if (tmp) tmp.style.display = 'flex'; }

    var dePincode = document.querySelector('#dePincode');
    if (dePincode) dePincode.value = currentLocation.pincode;

    var deResult = document.querySelector('#deResultText');
    if (deResult) { deResult.innerHTML = text; deResult.hidden = false; }
  }

  function showShippingMethods(currentLocation, available) {
    var deoptions = document.querySelectorAll('.de-option');
    var sameDay = document.querySelector('[data-delivery-type="Same Day"]');
    var nextDay = document.querySelector('[data-delivery-type="Next Day"]');
    var exprsDay = document.querySelector('[data-delivery-type="Express Delivery"]');
    var stndDay = document.querySelector('[data-delivery-type="Standard Delivery"]');
    deoptions.forEach(function (el) { el.classList.remove('active'); });

    var data = available.deliveryOptions;
    var method = available.fastestDelivery ? available.fastestDelivery.method : null;

    if (sameDay) {
      if (data && data.single_day_delivery && data.single_day_delivery.allowed) {
        sameDay.classList.remove('hide');
        sameDay.querySelector('.de-date').innerHTML = getFutureDate(Number(data.single_day_delivery.days)) || '';
        if (getISTNow().getHours() >= CFG.cutoffHour) sameDay.querySelector('.de-option-title').innerHTML = "Next-day delivery";
        if (method == 'Same Day') sameDay.classList.add('active');
      } else { sameDay.classList.add('hide'); }
    }
    if (nextDay) {
      if (data && data.next_day_delivery && data.next_day_delivery.allowed) {
        nextDay.classList.remove('hide');
        nextDay.querySelector('.de-date').innerHTML = getFutureDate(Number(data.next_day_delivery.days)) || '';
        nextDay.classList.add('active');
      } else { nextDay.classList.add('hide'); }
    }
    if (exprsDay) {
      if (data && data.express_delivery && data.express_delivery.allowed) {
        exprsDay.classList.remove('hide');
        exprsDay.querySelector('.de-date').innerHTML = getFutureDate(Number(data.express_delivery.days)) || '';
        if (method == 'Express Delivery') exprsDay.classList.add('active');
      } else { exprsDay.classList.add('hide'); }
    }
    if (stndDay) {
      if (data && data.standard_delivery && data.standard_delivery.allowed) {
        stndDay.classList.remove('hide');
        stndDay.querySelector('.de-date').innerHTML = getFutureDate(Number(data.standard_delivery.days)) || '';
        if (method == 'Standard Delivery') stndDay.classList.add('active');
      } else { stndDay.classList.add('hide'); }
    }
  }

  /* ---------- Optional cross-section modals (guarded) ---------- */
  function openLocationUpdateModal() { var m = document.querySelector('#locationUpdateModal'); if (m) m.style.display = 'block'; }
  function closeLocationUpdateModal() { var m = document.querySelector('#locationUpdateModal'); if (m) m.style.display = 'none'; }

  function applyNewPincode(pincode) {
    safeSetLS('currentLocation', { pincode: pincode, city: '', state: '', country: '' });
    safeSetLS('selectedDeliveryMethod', 'STANDARD DELIVERY');
    window.location.reload();
  }

  function updatePincodeInDOM(dePincode, currentLocation) {
    if (!dePincode || (currentLocation && dePincode == currentLocation.pincode)) return;
    fetchCartData().then(function (cartData) {
      var hasItems = cartData && cartData.items && cartData.items.length > 0;
      var proceedBtn = document.querySelector('#lcupProceedBtn');
      if (hasItems && !getFromLocalStorage('shownLocationChangeWarning') && proceedBtn) {
        openLocationUpdateModal();
        safeSetLS('shownLocationChangeWarning', 'true');
        var handler = function () { applyNewPincode(dePincode); closeLocationUpdateModal(); proceedBtn.removeEventListener('click', handler); };
        proceedBtn.addEventListener('click', handler);
        return;
      }
      applyNewPincode(dePincode);
    });
  }

  /* ---------- Main ---------- */
  function updateDeliveryElements(currentLocation) {
    return getDeliveryAvailabilityByZipcode(currentLocation.pincode).then(function (available) {
      var method = safeGetLS('selectedDeliveryMethod');
      var fastestDate = getFutureDate(available && available.fastestDelivery ? available.fastestDelivery.days : null);
      if (!method && available && available.fastestDelivery && available.fastestDelivery.method) {
        safeSetLS('selectedDeliveryMethod', available.fastestDelivery.method);
      }
      showDeliveryMsg(currentLocation, fastestDate);
      showShippingMethods(currentLocation, available);

      document.querySelectorAll('.de-option').forEach(function (el) {
        el.classList.remove('active');
        var radio = el.querySelector('input[type="radio"]');
        var m = safeGetLS('selectedDeliveryMethod');
        if (radio && radio.value === m) {
          setTimeout(function () {
            radio.checked = true;
            radio.dispatchEvent(new Event("change", { bubbles: true }));
            el.classList.add('active');
          }, 800);
        }
      });
    });
  }

  function bindOptionClicks() {
    document.querySelectorAll(".de-option").forEach(function (option) {
      if (option.dataset.deBound) return;
      option.dataset.deBound = '1';
      option.addEventListener("click", function () {
        if (option.classList.contains("hide")) return;
        var radio = option.querySelector('input[type="radio"]');
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
        document.querySelectorAll(".de-option").forEach(function (o) { o.classList.remove("active"); });
        option.classList.add("active");
        safeSetLS('selectedDeliveryMethod', radio.value);
      });
    });
  }

  function setupDeliveryOptions() {
    var GEO_KEY = 'browserGeoAsked';
    var currentLocation = safeGetLS('currentLocation');

    bindOptionClicks();

    var checkBtn = document.querySelector('#deCheckBtn');
    if (checkBtn && !checkBtn.dataset.deBound) {
      checkBtn.dataset.deBound = '1';
      checkBtn.addEventListener("click", function () {
        var v = (document.querySelector('#dePincode') || {}).value;
        updatePincodeInDOM(v, safeGetLS('currentLocation'));
      });
    }

    if (currentLocation && currentLocation.pincode) { updateDeliveryElements(currentLocation); return; }

    var fetched = safeGetLS('fetchedLocation');
    if (fetched && fetched.pincode) { safeSetLS('currentLocation', fetched); updateDeliveryElements(fetched); return; }

    if (!CFG.autoDetect) return;
    if (getSessionFlag(GEO_KEY)) return;
    setSessionFlag(GEO_KEY);
    if (!CFG.mapboxToken) return;

    detectPincodeUsingMapboxV6(CFG.mapboxToken).then(function (loc) {
      if (loc && loc.pincode) {
        safeSetLS('currentLocation', loc);
        safeSetLS('fetchedLocation', loc);
        updateDeliveryElements(loc);
      }
    }).catch(function (err) { /* denied / dismissed / blocked */ });
  }

  function init(scope) {
    var root = (scope || document).querySelector('[data-delivery-estimator]');
    if (!root || root.dataset.deInit) return;
    root.dataset.deInit = '1';
    CFG = {
      tatUrl: root.dataset.tatUrl,
      mapboxToken: root.dataset.mapboxToken,
      cutoffHour: parseInt(root.dataset.cutoffHour, 10) || 18,
      fallbackDays: parseInt(root.dataset.fallbackDays, 10) || 3,
      autoDetect: root.dataset.autoDetect === 'true'
    };
    // strip non-digits in the pincode field
    var pin = root.querySelector('#dePincode');
    if (pin) pin.addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 6); });
    setupDeliveryOptions();
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.classList.remove('shopify-section-header-show');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            if(this.headerIsAlwaysSticky != 'always'){
                                this.header.classList.add('shopify-section-header-hidden');
                            }
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
        super();
        }

        connectedCallback() {
        this.header = document.querySelector('.section-header-navigation');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
        }

        setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
        }

        onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');

            if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
            } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            document.body.classList.remove('scrolled-header');
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
        this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                this.header.classList.remove('shopify-section-header-hidden');
            }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            }
            }
        }

        closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            //   if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
            //       if (document.body.classList.contains('template-index')) {
            //           if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
            //               $('.vertical-menu').removeClass('vertical-menu__hide');
            //           }
            //       }
            //   }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, 99999);
      try { document.execCommand('copy'); resolve(); }
      catch (err) { reject(err); }
      finally { document.body.removeChild(ta); }
    });
  }

  function openModal(root) {
    var modal = root.querySelector('.offers-modal');
    var overlay = root.querySelector('.offers-overlay');
    if (!modal) return;
    root._lastFocus = document.activeElement;
    modal.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var c = root.querySelector('.js-offers-close');
    if (c) c.focus();
  }

  function closeModal(root) {
    var modal = root.querySelector('.offers-modal');
    var overlay = root.querySelector('.offers-overlay');
    if (modal) modal.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (root._lastFocus) root._lastFocus.focus();
  }

  function flashCode(btn) {
    var orig = btn.textContent;
    btn.classList.add('is-copied');
    btn.textContent = 'Copied \u2713';
    setTimeout(function () { btn.classList.remove('is-copied'); btn.textContent = orig; }, 1800);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-offers-root]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.offersInit) return;
      root.dataset.offersInit = '1';

      var openBtn = root.querySelector('.js-offers-open');
      if (openBtn) openBtn.addEventListener('click', function () { openModal(root); });

      Array.prototype.forEach.call(root.querySelectorAll('.js-offers-close, .offers-overlay'), function (el) {
        el.addEventListener('click', function () { closeModal(root); });
      });

      Array.prototype.forEach.call(root.querySelectorAll('.code-copy'), function (btn) {
        btn.addEventListener('click', function () {
          var code = (btn.getAttribute('data-code') || btn.textContent).trim();
          copyText(code).then(function () { flashCode(btn); });
        });
      });

      Array.prototype.forEach.call(root.querySelectorAll('.copy_btn'), function (btn) {
        btn.addEventListener('click', function () {
          var code = (btn.getAttribute('data-code') || '').trim();
          var wrap = btn.closest('.fst_coupon_wrapper');
          copyText(code).then(function () {
            if (wrap) {
              wrap.classList.add('is-copied');
              setTimeout(function () { wrap.classList.remove('is-copied'); }, 1800);
            }
          });
        });
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-offers-root]'), function (root) {
      if (root.querySelector('.offers-modal.is-open')) closeModal(root);
    });
  });

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(v) { return v; }

    function initCardVideos(root) {
      var cards = root.querySelectorAll('.sv-card');
      // Play/pause on scroll into view
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target.querySelector('video.sv-video');
            if (!v) return;
            if (entry.isIntersecting) {
              var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
              entry.target.classList.remove('is-paused');
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.5 });
        cards.forEach(function (c) { if (c.querySelector('video.sv-video')) io.observe(c); });
      } else {
        cards.forEach(function (c) { var v = c.querySelector('video.sv-video'); if (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); } });
      }

      // Mute toggle per card
      root.querySelectorAll('.js-sv-mute').forEach(function (btn) {
        function toggle(e) {
          e.preventDefault(); e.stopPropagation();
          var card = btn.closest('.sv-card');
          var v = card.querySelector('video.sv-video');
          if (!v) return;
          v.muted = !v.muted;
          card.classList.toggle('is-unmuted', !v.muted);
          if (!v.muted) { var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); }
        }
        btn.addEventListener('click', toggle);
        btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') toggle(e); });
      });
    }

    function initLightbox(root) {
      var lb = root.querySelector('.sv-lightbox');
      if (!lb) return;
      var lbVideo = lb.querySelector('.sv-lb-video');
      var lbProd  = lb.querySelector('.sv-lb-prod');
      var lbThumb = lb.querySelector('.sv-lb-thumb');
      var lbTitle = lb.querySelector('.sv-lb-title');
      var lbPrice = lb.querySelector('.sv-lb-price');
      var lbAtc   = lb.querySelector('.sv-lb-atc');
      var lbView  = lb.querySelector('.sv-lb-view');

      function open(card) {
        var d = card.dataset;
        if (d.video) { lbVideo.src = d.video; lbVideo.poster = d.poster || ''; lbVideo.muted = false; var pr = lbVideo.play(); if (pr && pr.catch) pr.catch(function(){}); }
        if (lbProd)  lbProd.href = d.url || '#';
        if (lbView)  lbView.href = d.url || '#';
        if (lbThumb) { lbThumb.src = d.image || ''; lbThumb.alt = d.title || ''; lbThumb.style.display = d.image ? '' : 'none'; }
        if (lbTitle) lbTitle.textContent = d.title || '';
        if (lbPrice) lbPrice.textContent = d.price || '';
        if (lbAtc)   { lbAtc.setAttribute('data-variant', d.variant || ''); lbAtc.style.display = d.variant ? '' : 'none'; lbAtc.classList.remove('is-added'); lbAtc.textContent = 'Add to cart'; }
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      function close() {
        lb.classList.remove('is-open');
        try { lbVideo.pause(); lbVideo.removeAttribute('src'); lbVideo.load(); } catch (e) {}
        document.body.style.overflow = '';
      }

      root.querySelectorAll('.js-sv-open').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (e.target.closest('.js-sv-mute')) return; // don't open when tapping mute
          open(btn.closest('.sv-card'));
        });
      });
      lb.querySelectorAll('.js-sv-close').forEach(function (el) { el.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) close(); });
    }

    function initAtc(root) {
      var after = root.dataset.afterAtc || 'stay';
      root.querySelectorAll('.js-sv-atc').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-variant');
          if (!id) return;
          var original = btn.textContent;
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
          }).then(function (r) { return r.json(); }).then(function () {
            if (after === 'checkout') { window.location.href = '/checkout'; return; }
            if (after === 'cart') { window.location.href = '/cart'; return; }
            btn.classList.add('is-added'); btn.textContent = 'Added \u2713';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = original; }, 1800);
          }).catch(function () {
            btn.disabled = false;
            window.location.href = '/cart/' + id + ':1';
          });
        });
      });
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-sv]').forEach(function (root) {
        if (root.dataset.svInit) return; root.dataset.svInit = '1';
        initCardVideos(root);
        initLightbox(root);
        initAtc(root);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    if (document.readyState !== 'loading') init(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stcky-footer-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const stickyFooter = document.getElementById('StickyFooterCta');
    if (!stickyFooter) return;

    // Anchor to the viewport even if a parent uses transform/filter/will-change
    if (stickyFooter.parentElement !== document.body) {
      document.body.appendChild(stickyFooter);
    }

    const buyBtn      = document.getElementById('StickyFooterBuyBtn');
    const priceEl     = document.getElementById('StickyFooterPrice');
    const mrpEl       = document.getElementById('StickyFooterMRP');
    const mrpWrapEl   = document.getElementById('StickyFooterMRPWrap');
    const savingsEl   = document.getElementById('StickyFooterSavings');
    const savingsAmtEl= document.getElementById('StickyFooterSavingsAmount');
    const imageEl     = document.getElementById('StickyFooterImage');
    const ratingEl    = document.getElementById('StickyFooterRating');
    const countEl     = document.getElementById('StickyFooterReviewCount');

    const config = {
      productId:       stickyFooter.dataset.productId,
      productHandle:   stickyFooter.dataset.productHandle,
      scrollMode:      stickyFooter.dataset.scrollMode || 'after-atc',
      scrollThreshold: parseInt(stickyFooter.dataset.scrollThreshold, 10) || 400,
      hideNearFooter:  stickyFooter.dataset.hideNearFooter === 'true',
      reviewSource:    stickyFooter.dataset.reviewSource || 'auto',
      fallbackRating:  stickyFooter.dataset.fallbackRating,
      fallbackCount:   stickyFooter.dataset.fallbackCount,
      widthMode:       stickyFooter.dataset.widthMode || 'auto',
      widthCustom:     parseInt(stickyFooter.dataset.widthCustom, 10) || 1200
    };

    /* ============================================================
       ADAPTIVE WIDTH — match product page container on desktop
       ============================================================ */
    function getProductContainer() {
      const candidates = [
        '.shopify-section--main-product .page-width',
        '.shopify-section[id*="main-product"] .page-width',
        'main .product__media-wrapper',
        '.product__media-wrapper',
        '.product-template__container',
        '.product-single__container',
        '[data-section-type="product"] .page-width',
        '[data-section-type="product"] .container',
        'main .page-width',
        'main .container',
        'main > .shopify-section .page-width',
        '.product-section .container',
        '.main-content .container'
      ];
      for (let i = 0; i < candidates.length; i++) {
        const el = document.querySelector(candidates[i]);
        if (el) {
          const w = el.getBoundingClientRect().width;
          if (w > 320) return el;
        }
      }
      return null;
    }

    function syncWidthToPage() {
      if (config.widthMode === 'full-width') {
        return;
      }
      if (config.widthMode === 'custom') {
        stickyFooter.style.setProperty('--sticky-footer-max-width', config.widthCustom + 'px');
        return;
      }
      const container = getProductContainer();
      if (container) {
        const rect = container.getBoundingClientRect();
        const w = Math.min(Math.round(rect.width), 1300);
        if (w > 320) {
          stickyFooter.style.setProperty('--sticky-footer-max-width', w + 'px');
        }
      } else {
        stickyFooter.style.setProperty('--sticky-footer-max-width', '1100px');
      }
    }

    syncWidthToPage();
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncWidthToPage, 80);
    }, { passive: true });
    setTimeout(syncWidthToPage, 300);
    setTimeout(syncWidthToPage, 1500);

    /* ============================================================
       SCROLL VISIBILITY
       ============================================================ */
    const mainAtcSelector = [
      'product-form button[type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] [type="submit"]',
      '.product-form__submit',
      '.product-form__buttons button',
      '.add-to-cart', '.add_to_cart', '.btn-addtocart', '.product-add-to-cart',
      'button[name="add"]',
      '[data-add-to-cart]',
      '#AddToCart', '#ProductSubmitButton',
      '[name="add"]'
    ].join(',');
    const mainAtc = document.querySelector(mainAtcSelector);
    const pageFooter = document.querySelector('footer, .site-footer, #shopify-section-footer, .footer');

    function setVisible(visible) {
      stickyFooter.classList.toggle('is-visible', visible);
      stickyFooter.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function checkNearFooter() {
      if (!config.hideNearFooter || !pageFooter) return false;
      // Only hide once the footer has actually scrolled into view.
      return pageFooter.getBoundingClientRect().top < (window.innerHeight - 10);
    }

    function updateVisibility() {
      if (checkNearFooter()) { setVisible(false); return; }
      switch (config.scrollMode) {
        case 'always':
          stickyFooter.classList.add('is-always-on');
          stickyFooter.setAttribute('aria-hidden', 'false');
          break;
        case 'after-atc':
          if (mainAtc) {
            const rect = mainAtc.getBoundingClientRect();
            setVisible(rect.bottom < 0);
          } else {
            setVisible(window.scrollY > config.scrollThreshold);
          }
          break;
        case 'threshold':
          setVisible(window.scrollY > config.scrollThreshold);
          break;
        case 'instant':
          setVisible(window.scrollY > 50);
          break;
        default:
          setVisible(window.scrollY > config.scrollThreshold);
      }
    }

    if (config.scrollMode === 'always') {
      stickyFooter.classList.add('is-always-on');
      stickyFooter.setAttribute('aria-hidden', 'false');
    }

    let ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    updateVisibility();

    /* ============================================================
       MONEY FORMATTING
       ============================================================ */
    function formatMoney(cents) {
      const value = (cents || 0) / 100;
      try {
        return '₹' + value.toLocaleString('en-IN', { maximumFractionDigits: 0 });
      } catch (e) {
        return '₹' + Math.round(value);
      }
    }

    /* ============================================================
       VARIANT SYNC — Multi-strategy approach
       ============================================================ */
    let cachedVariants = null;
    let productLoadPromise = null;
    let lastAppliedVariantId = stickyFooter.dataset.variantId;

    function loadProductData() {
      if (cachedVariants) return Promise.resolve(cachedVariants);
      if (productLoadPromise) return productLoadPromise;
      if (!config.productHandle) return Promise.resolve(null);

      productLoadPromise = fetch('/products/' + config.productHandle + '.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Product fetch failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          cachedVariants = data.variants || [];
          return cachedVariants;
        })
        .catch(function (err) {
          console.warn('[StickyFooter] Could not fetch product JSON:', err.message);
          productLoadPromise = null;
          return null;
        });
      return productLoadPromise;
    }

    function findVariantById(variantId) {
      if (!cachedVariants || !variantId) return null;
      const idStr = String(variantId);
      for (let i = 0; i < cachedVariants.length; i++) {
        if (String(cachedVariants[i].id) === idStr) return cachedVariants[i];
      }
      return null;
    }

    function applyVariantId(variantId) {
      if (!variantId) return;
      const idStr = String(variantId);
      if (idStr === String(lastAppliedVariantId)) return;
      lastAppliedVariantId = idStr;

      const cached = findVariantById(variantId);
      if (cached) {
        updateFromVariant(cached);
      } else {
        loadProductData().then(function () {
          const v = findVariantById(variantId);
          if (v) updateFromVariant(v);
        });
      }
    }

    function updateFromVariant(variant) {
      if (!variant) return;

      stickyFooter.setAttribute('data-variant-id', variant.id);
      stickyFooter.classList.toggle('is-soldout', !variant.available);

      if (buyBtn) {
        buyBtn.setAttribute('data-variant-id', variant.id);
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? 'BUY NOW' : 'SOLD OUT';
      }

      if (priceEl) {
        priceEl.classList.add('is-updating');
        setTimeout(function () {
          priceEl.textContent = formatMoney(variant.price);
          priceEl.classList.remove('is-updating');
        }, 100);
      }

      const cap = variant.compare_at_price || 0;
      if (cap > variant.price) {
        if (mrpEl) mrpEl.textContent = formatMoney(cap);
        if (mrpWrapEl) mrpWrapEl.style.display = '';
      } else {
        if (mrpWrapEl) mrpWrapEl.style.display = 'none';
      }

      const saved = cap - variant.price;
      if (saved > 0) {
        if (savingsAmtEl) savingsAmtEl.textContent = formatMoney(saved);
        if (savingsEl) savingsEl.style.display = '';
      } else {
        if (savingsEl) savingsEl.style.display = 'none';
      }

      if (imageEl && variant.featured_image && variant.featured_image.src) {
        imageEl.src = variant.featured_image.src;
      }
    }

    /* ----- Strategy 1: Preload product data ----- */
    loadProductData();

    /* ----- Strategy 2: URL change watching ----- */
    function getVariantFromUrl() {
      try {
        const params = new URLSearchParams(window.location.search);
        return params.get('variant');
      } catch (e) {
        const match = window.location.search.match(/[?&]variant=(\d+)/);
        return match ? match[1] : null;
      }
    }

    let lastUrlVariant = getVariantFromUrl();
    function checkUrlVariant() {
      const current = getVariantFromUrl();
      if (current && current !== lastUrlVariant) {
        lastUrlVariant = current;
        applyVariantId(current);
      }
    }
    window.addEventListener('popstate', checkUrlVariant);

    ['pushState', 'replaceState'].forEach(function (method) {
      const original = history[method];
      history[method] = function () {
        const result = original.apply(this, arguments);
        setTimeout(checkUrlVariant, 0);
        return result;
      };
    });

    /* ----- Strategy 3: Option picker change events ----- */
    function getCurrentFormVariantId() {
      const formInput = document.querySelector(
        'product-form input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
      );
      return formInput ? formInput.value : null;
    }

    document.addEventListener('change', function (e) {
      const target = e.target;
      if (!target || !target.matches) return;

      const isVariantInput = target.matches('input[name="id"], select[name="id"]');
      const isOptionInput  = target.matches(
        'input[name^="options"], select[name^="options"], ' +
        'variant-radios input, variant-selects select, ' +
        'fieldset.product-form__input input, fieldset.product-form__input select, ' +
        '[data-option-position] input, [data-option-position] select, ' +
        '.product-form__input input[type="radio"], .product-form__input select'
      );

      if (!isVariantInput && !isOptionInput) return;

      if (isVariantInput && target.value) {
        applyVariantId(target.value);
        return;
      }

      setTimeout(function () {
        const formVariant = getCurrentFormVariantId();
        if (formVariant) {
          applyVariantId(formVariant);
        } else {
          checkUrlVariant();
        }
      }, 60);
      setTimeout(function () {
        const formVariant = getCurrentFormVariantId();
        if (formVariant) applyVariantId(formVariant);
        else checkUrlVariant();
      }, 250);
    }, true);

    document.addEventListener('click', function (e) {
      const target = e.target.closest(
        '[data-variant-id], [data-option-value], ' +
        '.product-form__input label, .swatch-element, ' +
        'variant-radios label, .product-option label'
      );
      if (!target) return;

      const directVariantId = target.dataset.variantId;
      if (directVariantId) {
        applyVariantId(directVariantId);
        return;
      }

      setTimeout(function () {
        const formVariant = getCurrentFormVariantId();
        if (formVariant) applyVariantId(formVariant);
        else checkUrlVariant();
      }, 80);
      setTimeout(function () {
        const formVariant = getCurrentFormVariantId();
        if (formVariant) applyVariantId(formVariant);
        else checkUrlVariant();
      }, 350);
    }, true);

    /* ----- Strategy 4: MutationObserver on hidden variant input ----- */
    function watchVariantInput() {
      const inputs = document.querySelectorAll(
        'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
      );
      if (!inputs.length || !('MutationObserver' in window)) return;

      inputs.forEach(function (input) {
        const attrObserver = new MutationObserver(function () {
          if (input.value) applyVariantId(input.value);
        });
        attrObserver.observe(input, { attributes: true, attributeFilter: ['value'] });

        let last = input.value;
        setInterval(function () {
          if (input.value && input.value !== last) {
            last = input.value;
            applyVariantId(input.value);
          }
        }, 300);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchVariantInput);
    } else {
      watchVariantInput();
    }
    setTimeout(watchVariantInput, 1000);
    setTimeout(watchVariantInput, 3000);

    /* ----- Strategy 5: Custom theme events ----- */
    const customEvents = ['variant:change', 'product:variant-change', 'productVariantChanged', 'on:variant:change'];
    customEvents.forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (!e.detail) return;
        if (e.detail.variant) {
          updateFromVariant(e.detail.variant);
        } else if (e.detail.variantId) {
          applyVariantId(e.detail.variantId);
        } else if (e.detail.id) {
          applyVariantId(e.detail.id);
        }
      });
    });

    /* ============================================================
       AUTO REVIEW EXTRACTION
       ============================================================ */
    const reviewExtractors = {
      'judge.me': function () {
        const badge = document.querySelector('.jdgm-prev-badge, .jdgm-widget [data-average-rating]');
        if (!badge) return null;
        const rating = badge.getAttribute('data-average-rating');
        const count  = badge.getAttribute('data-number-of-reviews');
        if (!rating && !count) return null;
        return {
          rating: rating ? parseFloat(rating).toFixed(1) : null,
          count:  count ? parseInt(count, 10) : null,
          source: 'Judge.me'
        };
      },
      'yotpo': function () {
        const widget = document.querySelector('.yotpo-bottomline, .yotpo-display-wrapper');
        if (!widget) return null;
        const ratingEl = widget.querySelector('[class*="star-rating"], .yotpo-stars');
        const countEl  = widget.querySelector('.text-m, .yotpo-bottomline a, .yotpo-sum-reviews');
        const rating = ratingEl && (ratingEl.getAttribute('data-score') || (ratingEl.getAttribute('aria-label') || '').match(/[\d.]+/));
        const countMatch = countEl && countEl.textContent.match(/\d+/);
        return {
          rating: rating ? (Array.isArray(rating) ? rating[0] : rating).toString() : null,
          count:  countMatch ? parseInt(countMatch[0], 10) : null,
          source: 'Yotpo'
        };
      },
      'loox': function () {
        const widget = document.querySelector('.loox-rating, [data-loox-rating]');
        if (!widget) return null;
        const rating = widget.getAttribute('data-rating');
        const count  = widget.getAttribute('data-count') || widget.getAttribute('data-num-reviews');
        const text   = widget.textContent || '';
        const countMatch = count || (text.match(/\((\d+)\)/) || [])[1];
        return {
          rating: rating ? parseFloat(rating).toFixed(1) : null,
          count:  countMatch ? parseInt(countMatch, 10) : null,
          source: 'Loox'
        };
      },
      'stamped': function () {
        const badge = document.querySelector('.stamped-product-reviews-badge, .stamped-badge');
        if (!badge) return null;
        const rating = badge.getAttribute('data-rating');
        const count  = badge.getAttribute('data-reviews') || badge.getAttribute('data-review-count');
        return {
          rating: rating ? parseFloat(rating).toFixed(1) : null,
          count:  count ? parseInt(count, 10) : null,
          source: 'Stamped.io'
        };
      },
      'shopify-reviews': function () {
        const badge = document.querySelector('.spr-badge, [data-rating]');
        if (!badge) return null;
        const rating = badge.getAttribute('data-rating');
        const countEl = badge.querySelector('.spr-badge-caption');
        const countMatch = countEl && countEl.textContent.match(/\d+/);
        return {
          rating: rating ? parseFloat(rating).toFixed(1) : null,
          count:  countMatch ? parseInt(countMatch[0], 10) : null,
          source: 'Shopify Reviews'
        };
      },
      'json-ld': function () {
        const scripts = document.querySelectorAll('script[type="application/ld+json"]');
        for (let i = 0; i < scripts.length; i++) {
          try {
            const data = JSON.parse(scripts[i].textContent);
            const items = Array.isArray(data) ? data : [data];
            for (let j = 0; j < items.length; j++) {
              const item = items[j];
              const agg = item.aggregateRating || (item['@graph'] && item['@graph'].find(function (x) { return x.aggregateRating; }));
              if (agg && agg.aggregateRating) {
                return {
                  rating: parseFloat(agg.aggregateRating.ratingValue).toFixed(1),
                  count:  parseInt(agg.aggregateRating.reviewCount || agg.aggregateRating.ratingCount, 10),
                  source: 'JSON-LD'
                };
              }
              if (agg && agg.ratingValue) {
                return {
                  rating: parseFloat(agg.ratingValue).toFixed(1),
                  count:  parseInt(agg.reviewCount || agg.ratingCount, 10),
                  source: 'JSON-LD'
                };
              }
            }
          } catch (e) { /* skip */ }
        }
        return null;
      }
    };

    function formatCount(num) {
      if (!num || isNaN(num)) return null;
      if (num >= 100000) return (num / 100000).toFixed(1).replace(/\.0$/, '') + 'L+';
      if (num >= 1000)   return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K+';
      return num + '+';
    }

    function applyReviewData(data) {
      if (!data) return false;
      let updated = false;
      if (data.rating && ratingEl) {
        ratingEl.textContent = '★ ' + data.rating;
        updated = true;
      }
      if (data.count && countEl) {
        countEl.textContent = formatCount(data.count);
        updated = true;
      }
      if (updated) console.log('[StickyFooter] Reviews loaded from:', data.source);
      return updated;
    }

    function extractReviews() {
      let data = null;
      if (config.reviewSource === 'auto') {
        const order = ['judge.me', 'yotpo', 'loox', 'stamped', 'shopify-reviews', 'json-ld'];
        for (let i = 0; i < order.length; i++) {
          data = reviewExtractors[order[i]]();
          if (data && (data.rating || data.count)) break;
        }
      } else if (reviewExtractors[config.reviewSource]) {
        data = reviewExtractors[config.reviewSource]();
      }
      applyReviewData(data);
      return data;
    }

    extractReviews();
    setTimeout(extractReviews, 1000);
    setTimeout(extractReviews, 3000);

    if ('MutationObserver' in window) {
      let extractAttempts = 0;
      const reviewObserver = new MutationObserver(function () {
        if (extractAttempts > 8) { reviewObserver.disconnect(); return; }
        extractAttempts++;
        const result = extractReviews();
        if (result && result.rating && result.count) reviewObserver.disconnect();
      });
      reviewObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { reviewObserver.disconnect(); }, 10000);
    }

    /* ============================================================
       BUY NOW HANDLER
       ============================================================ */
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        const variantId = buyBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        buyBtn.disabled = true;
        const originalText = buyBtn.textContent;
        buyBtn.textContent = 'ADDING...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) { return res.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            console.error('[StickyFooter] ATC failed:', err);
            buyBtn.disabled = false;
            buyBtn.textContent = originalText;
            window.location.href = '/cart/' + variantId + ':1';
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
